import { useMemo } from 'react';

import useSpendLimitsPeriod from '../../SpendLimitsTable/hooks/useSpendLimitsPeriod';
import useGetCategorySpendLimitsQuery from '../queries/useGetCategorySpendLimits.query';

import { useCategorySpendLimitsData } from './useCategorySpendLimitsData';

interface Props {
  accountId?: string;
}

const useCategorySpendLimits = ({ accountId }: Props) => {
  const { showPeriodDropdown, periodOptions, selectedPeriod, handlePeriodChange, isPeriodLoading } =
    useSpendLimitsPeriod({ accountId });

  const { categorySpendLimits, isLoading } = useGetCategorySpendLimitsQuery({
    accountId,
    periodFrom: selectedPeriod,
  });

  const categorySpendLimitsData = useCategorySpendLimitsData({
    categorySpendLimits,
  });

  const hasCategorySpendLimits = useMemo(
    () => categorySpendLimits && categorySpendLimits.length > 0,
    [categorySpendLimits]
  );

  return {
    categorySpendLimitsData,
    isCategorySpendLimitsLoading: isLoading,
    hasCategorySpendLimits,
    showPeriodDropdown,
    periodOptions,
    selectedPeriod,
    handlePeriodChange,
    isPeriodLoading,
  };
};

export default useCategorySpendLimits;
